import { defineBlock, ChildrenBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import React from 'react';

const ALLOWED_BLOCKS = [
    'smartfire/contact---form---form-content---input',
    'smartfire/contact---form---form-content---select',
    'smartfire/contact---form---form-content---textarea',
    'smartfire/contact---form---form-content---checkbox',
    'smartfire/contact---form---form-content---sumbit',
];

const Inspector = React.lazy(() => import('./Inspector.js'));

const TwoColumns = ({ widthColumn }) => {
    useInspectorControl(Inspector);

    return (
        <ChildrenBlock
            gutenbergEditorConfig={{
                allowedBlocks: ALLOWED_BLOCKS,
                template: [
                    ['smartfire/contact---form---form-content---input'],
                    ['smartfire/contact---form---form-content---input'],
                ],
                templateLock: false,
            }}
            className={style.blockTwoColumns}
            style={{ gridTemplateColumns: widthColumn + '% auto' }}
        />
    );
};

export default defineBlock({
    Block: TwoColumns,
    smartProps: {
        widthColumn: smartProps.number.withDefault(50),
    },
    setup: {
        title: 'Deux colonnes',
        parent: ['smartfire/contact---form---form-content'],
    },
});
